export default __webpack_public_path__ + "static/poster-8222cc2e16913ea9c33d9d99089c22db.png";